export default __webpack_public_path__ + "static/media/references__wealth.81ce575b.jpg";